import React from 'react'
import BlogPost from './BlogPost'

export default function PlaceToReturn() {
  return (
    <BlogPost
      translationKey="placeToReturn"
      seoTitle="돌아갈 곳 | Hyunjin Jae"
      seoDescription="돌아간다는 것이 무엇을 의미하는지에 대한 짧은 생각입니다."
      seoKeywords="돌아갈 곳, 고향, 관계, 귀향, home, return, relationship"
      seoTags={['home', 'return', 'reflection']}
    />
  )
}
